import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class MenuGroupSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      valid: true,
      msg: "",
      toastColor: "",
      menuGroups: [],
      editing: false,
      menuPopup: false,
      page: 0,
      size: 10,
      totalPages: 1,
      // Flattened menu group state
      id: 0,
      name: "",
      activeStatus: "YES",
      menus: [], // Array of {id, name, menuFunction, activeStatus}
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleMenuChange = this.handleMenuChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleShowMenus = this.handleShowMenus.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleBackFromMenus = this.handleBackFromMenus.bind(this);
    this.handleAddMenu = this.handleAddMenu.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchMenuGroups = this.fetchMenuGroups.bind(this);
    this.fetchMenuGroupById = this.fetchMenuGroupById.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchMenuGroups(0, 10, token);
  }

  fetchMenuGroups(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getmenugroups", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let groups = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          groups = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          groups = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          groups = [];
        }
        this.setState({
          menuGroups: groups,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          menuGroups: [],
          totalPages: 1,
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load menu groups.",
          msg: error?.response?.data?.message || "Failed to load menu groups.",
          toastColor: "danger",
        });
      });
  }

  fetchMenuGroupById(id, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + `/settings/getmenugroupbyid/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data) {
          const data = response.data;
          this.setState({
            id: data.id || 0,
            name: data.name || "",
            activeStatus: data.activeStatus || "YES",
            menus: data.menus || [],
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load menu group.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleMenuChange(index, field, value) {
    const menus = [...this.state.menus];
    menus[index] = { ...menus[index], [field]: value };
    this.setState({ menus }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (s.editing) {
      if (!s.name || !s.name.trim()) {
        errors.name = "Menu group name is required";
        valid = false;
      }
      if (!s.activeStatus || !s.activeStatus.trim()) {
        errors.activeStatus = "Active status is required";
        valid = false;
      }
      // Validate menus
      const menuErrors = [];
      s.menus.forEach((menu, index) => {
        const menuErr = {};
        if (!menu.name || !menu.name.trim()) {
          menuErr.name = "Menu name is required";
          valid = false;
        }
        if (!menu.menuFunction || !menu.menuFunction.trim()) {
          menuErr.menuFunction = "Menu function is required";
          valid = false;
        }
        if (!menu.activeStatus || !menu.activeStatus.trim()) {
          menuErr.activeStatus = "Active status is required";
          valid = false;
        }
        if (Object.keys(menuErr).length > 0) {
          menuErrors[index] = menuErr;
        }
      });
      if (menuErrors.length > 0) {
        errors.menus = menuErrors;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    // Prepare data: set menuGroupName for each menu
    const menus = this.state.menus.map((menu) => ({
      ...menu,
      menuGroupName: this.state.name,
    }));

    const request = {
      id: this.state.id,
      name: this.state.name,
      activeStatus: this.state.activeStatus,
      menus,
    };

    const self = this;
    axios
      .post(API + "/settings/menugroupsave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Menu group saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            id: 0,
            name: "",
            activeStatus: "YES",
            menus: [],
            editing: false,
            errors: {},
          });
          // Refetch groups
          const currentPage = self.state.page;
          self.fetchMenuGroups(currentPage, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save menu group.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save menu group. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(group) {
    const token = sessionStorage.getItem("token");
    if (group && group.id) {
      this.fetchMenuGroupById(group.id, token);
    } else {
      // New
      this.setState(
        {
          id: 0,
          name: "",
          activeStatus: "YES",
          menus: [],
          editing: true,
          errors: {},
        },
        this.validate
      );
    }
    this.setState({ editing: true, menuPopup: false });
  }

  handleShowMenus(group) {
    const token = sessionStorage.getItem("token");
    this.fetchMenuGroupById(group.id, token);
    this.setState({ menuPopup: true, editing: false });
  }

  handleCancelEdit() {
    this.setState({
      id: 0,
      name: "",
      activeStatus: "YES",
      menus: [],
      editing: false,
      menuPopup: false,
      errors: {},
    });
  }

  handleBackFromMenus() {
    this.setState({ menuPopup: false });
  }

  handleAddMenu() {
    const newMenu = {
      id: 0,
      name: "",
      menuFunction: "",
      activeStatus: "YES",
    };
    this.setState(
      (prevState) => ({
        menus: [...prevState.menus, newMenu],
      }),
      this.validate
    );
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchMenuGroups(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchMenuGroups(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Menu Group Settings" />
          {divMsg}
          <div className="w-full grow px-5 h-[60%]">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="flex flex-col items-center w-full mt-2 pt-3 pb-2 h-full overflow-y-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="grid grid-cols-2 gap-x-8 gap-y-4 w-full max-w-5xl">
                  <div className="input-group">
                    <label className="input-group-text">Menu Group Name</label>
                    <input
                      name="name"
                      className={`form-control ${
                        s.errors.name ? " !border-red-500" : ""
                      }`}
                      value={s.name}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.name && (
                      <span className="input-group-error">{s.errors.name}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.activeStatus}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="">Select</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex justify-start w-full mt-4">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.handleAddMenu}
                  >
                    Add Menu
                  </button>
                </div>
                <div className="grow overflow-y-auto w-full mt-4">
                  {s.menus.length > 0 ? (
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Menu Function
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Active Status
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.menus.map((menu, index) => (
                          <tr key={index}>
                            <td className="px-6 py-4">
                              <div className="input-group border-0">
                                <input
                                  name={`menuName_${index}`}
                                  className={`form-control ${
                                    s.errors.menus &&
                                    s.errors.menus[index] &&
                                    s.errors.menus[index].name
                                      ? " !border-red-500"
                                      : ""
                                  }`}
                                  value={menu.name}
                                  onChange={(e) =>
                                    this.handleMenuChange(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  required
                                />
                                {s.errors.menus &&
                                  s.errors.menus[index] &&
                                  s.errors.menus[index].name && (
                                    <span className="input-group-error">
                                      {s.errors.menus[index].name}
                                    </span>
                                  )}
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="input-group border-0">
                                <input
                                  name={`menuFunction_${index}`}
                                  className={`form-control ${
                                    s.errors.menus &&
                                    s.errors.menus[index] &&
                                    s.errors.menus[index].menuFunction
                                      ? " !border-red-500"
                                      : ""
                                  }`}
                                  value={menu.menuFunction}
                                  onChange={(e) =>
                                    this.handleMenuChange(
                                      index,
                                      "menuFunction",
                                      e.target.value
                                    )
                                  }
                                  required
                                />
                                {s.errors.menus &&
                                  s.errors.menus[index] &&
                                  s.errors.menus[index].menuFunction && (
                                    <span className="input-group-error">
                                      {s.errors.menus[index].menuFunction}
                                    </span>
                                  )}
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="input-group border-0">
                                <select
                                  name={`activeStatus_${index}`}
                                  className={`form-control ${
                                    s.errors.menus &&
                                    s.errors.menus[index] &&
                                    s.errors.menus[index].activeStatus
                                      ? " !border-red-500"
                                      : ""
                                  }`}
                                  value={menu.activeStatus}
                                  onChange={(e) =>
                                    this.handleMenuChange(
                                      index,
                                      "activeStatus",
                                      e.target.value
                                    )
                                  }
                                  required
                                >
                                  <option value="">Select</option>
                                  <option value="YES">Yes</option>
                                  <option value="NO">No</option>
                                </select>
                                {s.errors.menus &&
                                  s.errors.menus[index] &&
                                  s.errors.menus[index].activeStatus && (
                                    <span className="input-group-error">
                                      {s.errors.menus[index].activeStatus}
                                    </span>
                                  )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-gray-500">No menus added.</div>
                  )}
                </div>
                <div className="flex justify-center gap-8 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                {!s.menuPopup ? (
                  <>
                    <div className="flex gap-2 mb-2 items-baseline justify-between">
                      <h3 className="font-bold">Configured Menu Groups</h3>
                      <button
                        className="hover:font-bold flex gap-1 group"
                        onClick={() => this.handleEdit(null)}
                      >
                        <i
                          className="bi bi-plus-circle group-hover:scale-105"
                          style={{ color: "black" }}
                        ></i>
                        Add
                      </button>
                    </div>
                    {s.menuGroups.length === 0 ? (
                      <div className="text-gray-500">No menu groups found.</div>
                    ) : (
                      <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-50 sticky top-0">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                ID
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Active Status
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {s.menuGroups.map((group, index) => (
                              <tr key={index} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {group.id}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {group.name}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {group.activeStatus}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                  <button
                                    className="btn btn-success mr-2"
                                    onClick={() => this.handleShowMenus(group)}
                                  >
                                    Show Menus
                                  </button>
                                  <button
                                    className="btn btn-success"
                                    onClick={() => this.handleEdit(group)}
                                  >
                                    Edit
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {s.totalPages > 1 && (
                      <div className="flex justify-center items-center gap-2 mt-4">
                        <button
                          className="btn btn-outline"
                          disabled={s.page === 0}
                          onClick={this.handlePreviousPage}
                        >
                          Previous
                        </button>
                        <span>
                          Page {s.page + 1} of {s.totalPages}
                        </span>
                        <button
                          className="btn btn-outline"
                          disabled={s.page + 1 >= s.totalPages}
                          onClick={this.handleNextPage}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  // Menus View
                  <>
                    <div className="flex gap-2 mb-2 items-baseline justify-between">
                      <h3 className="font-bold">
                        Configured Menus for Menu Group '{s.name}'
                      </h3>
                      <button
                        className="btn btn-success"
                        onClick={this.handleBackFromMenus}
                      >
                        Back
                      </button>
                    </div>
                    {s.menus.length === 0 ? (
                      <div className="text-gray-500">No menus found.</div>
                    ) : (
                      <div className="overflow-x-auto w-full border h-[90%] relative overflow-y-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-50 sticky top-0">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                ID
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Menu Function
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Active Status
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {s.menus.map((menu, index) => (
                              <tr key={index} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {menu.id}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {menu.name}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {menu.menuFunction}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {menu.activeStatus}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
